/**
 * MinigameSplash - Splash-Screen wenn ein Minispiel startet
 *
 * Verwendet den gleichen Stil wie PhaseSplash ("Shoppen!", "Los geht's!" etc.)
 * Einfacher Badge + Icon + Text, automatische Ausblendung.
 */
import React, { useEffect, useCallback } from 'react';
import socketService from '../../socketService';
import soundService from '../../soundService';
import { MINIGAME_EVENTS } from '../../shared/core/minigameConstants';
import { SPLASHES } from '../../config/animationTimings';
import '../playing/PhaseSplash.css'; // Nutzt PhaseSplash Styles

const SPLASH_DURATION = SPLASHES?.phaseDuration || 1500;

export default function MinigameSplash({
  minigameId,
  name,
  description,
  icon,
  triggeredBy,
  onComplete,
}) {
  // Auto-dismiss after duration
  useEffect(() => {
    soundService.play('phase_transition');

    const timer = setTimeout(() => {
      // Notify server we're ready
      socketService.emit(MINIGAME_EVENTS.SPLASH_COMPLETE);
      onComplete?.();
    }, SPLASH_DURATION);

    return () => clearTimeout(timer);
  }, [onComplete]);

  // Allow click to dismiss early
  const handleClick = useCallback(() => {
    socketService.emit(MINIGAME_EVENTS.SPLASH_COMPLETE);
    onComplete?.();
  }, [onComplete]);

  return (
    <div className="phase-splash" onClick={handleClick}>
      <div className="phase-splash-content">
        <div className="phase-splash-badge">
          Minispiel
        </div>
        <div className="phase-splash-text">
          <span className="phase-splash-icon">{icon || '🎮'}</span>
          <span className="phase-splash-label">{name || 'Unbekannt'}</span>
        </div>
      </div>
    </div>
  );
}
